import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const DeliveryCounter = () => {
  const [time, setTime] = useState("00:00:00");
  const [timeUpto, setTimeUpto] = useState<any>();

  const getStartTime = () => {
    const now = new Date();
    let timeUpto;
    if (now.getHours() < 18) {
      timeUpto = new Date(now.setHours(18));
    } else {
      timeUpto = new Date(now.setDate(now.getDate() + 1));
      timeUpto.setHours(18);
    }
    timeUpto.setMinutes(0);
    timeUpto.setSeconds(0);
    setTimeUpto(timeUpto);
  };

  useEffect(() => {
    getStartTime();
    window.addEventListener("focus", getStartTime);
    return () => {
      window.removeEventListener("focus", getStartTime);
    };
  }, []);

  const getTime = () => {
    const now = new Date();
    const startDate = timeUpto;
    const diff = startDate.getTime() - now.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    setTime(`${days}D : ${hours}H : ${minutes}M : ${seconds}S`);
  };

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> = setInterval(() => {
      if (timeUpto) {
        getTime();
      }
    }, 1000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [getTime, timeUpto]);

  return <>{time}</>;
};

export default DeliveryCounter;
